var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"toolbar-button z-body-small",class:{
		'toolbar-button--active': _vm.isActive,
		'toolbar-button--square': _vm.isSquare,
		'toolbar-button--rounded-left': _vm.isRoundedLeft,
		'toolbar-button--rounded-right': _vm.isRoundedRight
	}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }